(function ($) {
    $(document).ready(function () {
        const $products = $('.woocommerce .products');

        $products.on('click', '.quantity .qty', function () {
            return false;
        });

        $products.on('change', '.qty', function () {
            const $addToCartButton = $(this).parents('.product').find('.add_to_cart_button');

            // For AJAX add-to-cart actions
            $addToCartButton.attr('data-quantity', $(this).val());

            // For non-AJAX add-to-cart actions
            $addToCartButton.attr('href', '?add-to-cart=' + $addToCartButton.attr('data-product_id') + '&quantity=' + $(this).val());
        });

        // Trigger on Enter press
        $products.on('keypress', '.quantity .qty', function (e) {
            if ((e.which || e.keyCode) === 13) {
                $(this).parents('.product').find('.add_to_cart_button').trigger('click');
            }
        });

    });

})(jQuery);

